export enum PageName {
  SEARCH = 'page.Hotels.Search',
  SEARCH_PACKAGE_HC = 'page.Package.HC.Hotel-Search',
  SEARCH_PACKAGE_FH = 'page.Package.FH.Hotel-Search',
  SEARCH_PACKAGE_FHC = 'page.Package.FHC.Hotel-Search',
  INFOSITE = 'page.Hotels.Infosite.Information'
}
